// extracted by mini-css-extract-plugin
export default {"container":"orderList_container__QeCxH"};